import { ReactNode } from 'react';
import { Tooltip } from '@bst/react-ui';
import { useCanvasTextWidth } from '../../../hooks/useCanvasTextWidth';

type Props = {
  text: string;
  fontSize?: number;
  fontStyle?: string;
  fontFamily?: string;
  fontWeight?: string;
  threshold: number;
  children: ReactNode
};

/**
 * Conditionally render tooltip
 * Only if text is longer then width
 */
export const ConditionalFitTooltip = ({
  text,
  threshold,
  children,
  ...rest
}: Props) => {
  const getTextWidth = useCanvasTextWidth()
  const textWidth = getTextWidth({ text, ...rest });
  const isOverflowing = textWidth ? textWidth >= threshold : false
  if (isOverflowing) {
    return (<Tooltip content={text}>{children}</Tooltip>)
  }
  return (<>{children}</>)
}
